<template>
	<div class="address-box">
		<Modal v-model="showModal" width="696" @on-cancel="cancel"  :styles="{top: '300px'}">
			<p slot="header" class="ivu-modal-header">
				<Icon type="information-circled"></Icon>
				<span>新增收货地址</span>
			</p>
			<div class="address">
				<div class="row">
					<div class="item">
						<div class="title"> 收货人:</div>
						<Input v-model="info.consignee" placeholder="请填写收货人姓名" style="width: 200px;"></Input>

					</div>
					<div class="item">
						<div class="title"> 手机号码: </div>
						<Input v-model="info.mobile" placeholder="请填写收货人手机号码" style="width: 200px;"></Input>
					</div>
				</div>
				<div class="item">
					<div class="title"> 所在地址: </div>
					<div style="width: 530px;height:40px;">
						<Cascader :data="addData" v-model="value" placeholder="请选择地址"></Cascader>
					</div>
				</div>
				<div class="item" style="margin-bottom: 10px;">
					<div class="title"> 详细地址: </div>
					<Input v-model="info.address" type="textarea" placeholder="请输入详细地址" style="width: 530px;"></Input>
				</div>
				<div class="item" >
					<div class="title">  </div>
					<label class=" flex align-center" @click="changeDefault">
						<img src="../assets/images/icon-selected.png"
						class='default' v-if="info.is_default" />
						<img src="../assets/images/icom-choose.png"
						class='default' v-if="!info.is_default" />
						<span>设置为默认收货地址</span>
					</label>
				</div>
			</div>
			<div slot="footer">
				<div class="submit" @click="submit">保存</div>
			</div>
		</Modal>

	</div>
</template>

<script>

	import addData from "../assets/provinces.js"
	import { saveAddress } from "@/api"
	export default {
		name: "Address",
		props: {
			show: Boolean,
			item:{
				type:Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				showModal: false,
				value: [],
				addData: addData,
				info:{
					address_id: 0,
					consignee: '',
					mobile: '',
					address: '',
					country_name: "中国",
					province_name:'',
					city_name: "",
					zone_name: "",
					zip_code: '',
					is_default: false,
				}
			};
		},
		watch: {
			show(e) {
				this.showModal = e;
			},
			item(e) {
				if(e?.address_id) {
					this.info = e
					this.value = [this.info.province_name,this.info.city_name,this.info.zone_name]
				} else {
					this.info = {
						address_id: 0,
						consignee: '',
						mobile: '',
						address: '',
						country_name: "中国",
						province_name:'',
						city_name: "",
						zone_name: "",
						zip_code: '',
						is_default: false,
					}
					this.value = []
				}
			}
		},
		methods: {
			cancel() {
				this.$emit("cancel");
			},
			changeDefault() {
				this.info.is_default = !this.info.is_default
			},
			submit() {
				this.info.province_name = this.value[0]
				this.info.city_name = this.value[1]
				this.info.zone_name = this.value[2]
				saveAddress(this.info).then((res)=>{
					if(res.code == 0) {
						this.$emit("addAddress");
					}
				})
			}
		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>
	.address {

		background: #ffffff;
		opacity: 1;
		border-radius: 10px;
		padding: 14px 24px 0 24px;
	}

	.row {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		.title {
			width: 86px;
			height: 40px;
			line-height: 40px;
			text-align: left;
			font-size: 15px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
		}

		input {
			height: 40px;
			border: 1px solid #dddddd;
			padding-left: 10px;
		}

		textarea {
			width: 500px;
			height: 70px;
			border: 1px solid #DDDDDD;
			padding: 10px;
		}
		.default{
			width: 14px;
			height: 14px;
			margin-right: 5px;
		}
	}

	.submit {
		width: 230px;
		height: 44px;
		line-height: 44px;
		background: #0F114A;
		opacity: 1;
		border-radius: 4px;
		text-align: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #EDD4AC;
		margin: 0 auto;
		cursor: pointer;
	}

	.ivu-modal-footer {
		border-top: none !important;
	}
</style>
